<era-pane>
  <h5 class="small-caps"
      i18n>Data Roaming</h5>
  <form [formGroup]="dataRoamingForm"
        (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <div class="form-check form-switch">
        <input type="checkbox"
               class="form-check-input rounded-3"
               role="switch"
               formControlName="dataRoamingEnabled"
               id="dataRoamingEnabled" />
        <label class="form-check-label"
               for="dataRoamingEnabled">Turn Data Roaming {{ (dataRoamingEnabled.valueChanges | async) ? 'On' : 'Off'
          }}</label>
        <small class="form-text text-muted"> Enabling data roaming also enables voice roaming. </small>
      </div>
    </div>
    <button class="btn btn-primary"
            type="submit"
            [disabled]="!dataRoamingForm.valid">Submit</button>
  </form>
</era-pane>